import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {
  ContactsStoredType,
} from '@contact/types/enums';

// 즐겨찾기한 연락처 목록 조회할 기본 폴더
let favoriteFolder = Object.create(null) as contacts.FolderItem;
favoriteFolder.id = 'favorite';
favoriteFolder.name = '연락처';
favoriteFolder.displayName = '연락처';
favoriteFolder.isFavorite = true;
//favoriteFolder.folderType = ContactFolderType.Favorite,
favoriteFolder.selected = false;
favoriteFolder.nodeStatus = null;
// 공유받은 연락처 목록 조회할 기본 폴더
let sharedFolder = Object.create(null) as contacts.FolderItem;
sharedFolder.id = 'shared';
sharedFolder.name = '공유받은 연락처';
sharedFolder.displayName = '공유받은 연락처';
sharedFolder.isFavorite = false;
sharedFolder.isShared = true;
//sharedFolder.folderType = ContactFolderType.Shared,
sharedFolder.selected = false;
sharedFolder.nodeStatus = null;

// initial state
const state: contact.state.ContactState = {
  currentContactItem: {
    displayName: '',
    surname: '',
    givenName: '',
    email: '',
    companyName: '',
    department: '',
    jobTitle: '',
    officeLocation: '',
    hasPicture: false,
    mobile: '',
    businessPhone: '',
    businessFax: '',
    businessHomePage: '',
    businessAddress: {
      city: '',
      countryOrRegion: '',
      postalCode: '',
      state: '',
      street: '',
    } as contacts.ContactAddresses,
    homeAddress: {
      city: '',
      countryOrRegion: '',
      postalCode: '',
      state: '',
      street: '',
    } as contacts.ContactAddresses,
    deletedDate: '',
    attachments: [] as any,
    photoPath: '',
    targetPersonCode: '',
    parentFolderId: '',
    itemClass: null,
    storedType: ContactsStoredType.DB,
    type: null,
    status: null,
    isSharing: false,
    isShared: false,
  } as contacts.ContactItem,

  listMode: {
    showCheckbox: false,
    showEditToolbar: false,
    selectContactId: [],
    showSearch: false,
  } as contacts.ListMode,
  folders: {
    favorite: [favoriteFolder],
    //exchange 버전
    personal: [],
    //database 버전
    local: [],
    departmental: [],
    shared: [sharedFolder],
    public: Object.create(null),
    trash: Object.create(null),
    current: Object.create(null),
  },
  contacts: {
    lists: {
      items: [],
    },
    modalStatus: false,
    current: null,
    new: {
      folder: Object.create(null),
      item: Object.create(null),
      members: Object.create(null),
      error: {
        givenName: '',
        email: '',
        mobile: '',
        postalCode: '',
        businessPhone: '',
        businessFax: '',
      },
    },
    members: {
      type: null,
      items: [],
    },
    selections: [],
    selectionFrom: '',
  },
  toolbar: {
    search: Object.create(null),
    sorts: [],
    folder: null,
    filter: [],
  },
  share: {
    folder: Object.create(null),
    item: Object.create(null),
    members: Object.create(null),
    error: Object.create(null),
  },
  loading: true,
};

export default {
  state,
  actions,
  getters,
  mutations,
};
